import { render, staticRenderFns } from "./newcomer-task.vue?vue&type=template&id=ac544736&scoped=true"
import script from "./newcomer-task.vue?vue&type=script&lang=js"
export * from "./newcomer-task.vue?vue&type=script&lang=js"
import style0 from "./newcomer-task.vue?vue&type=style&index=0&id=ac544736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac544736",
  null
  
)

export default component.exports